import React, { useState, useEffect } from 'react';
import { emailRegex, FormState, passwordRegex } from '@opu/utils';
import { useHistory, useLocation } from 'react-router-dom';
import AxiosInstance from '../../../helpers/AxiosInstance';
import firebaseApp, { auth } from '../../../firebase-init';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';

const useForm = () => {
  const { t, i18n } = useTranslation();

  let history = useHistory();
  let location = useLocation();

  const [formInputs, setFormInputs] = useState({ email: '' });
  const [errors, setErrors] = useState(null);
  const [loading, setLoading] = useState(false);

  const submitHandler = async (e) => {
    setLoading(true);
    e.preventDefault();
    setErrors(null);

    AxiosInstance.post(`/auth/send-password-recovery-email`, { email: formInputs.email })
      .then((res) => {
        Swal.fire(t('PASSWORD_RESET_SUCCESS'), '', 'success');
      })
      .catch((error) => {
        if (error.data.message[0]?.includes('EMAIL')) {
          setErrors(t(error.data.message[0]));
        } else Swal.fire(t('PASSWORD_RESET_FAILED'), '', 'error');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return {
    submitHandler,
    formInputs,
    setFormInputs,
    errors,
    loading,
  };
};

export default useForm;
